import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const CHECK_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE';

/**
 * Validador de NIF español (DNI o NIE). Vacío = válido (usar Validators.required aparte si aplica).
 */
export function nifValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const raw = control.value;
		if (raw === null || raw === undefined || String(raw).trim() === '') {
			return null;
		}

		const nif = String(raw).trim().toUpperCase().replace(/\s/g, '');
		if (!isValidSpanishNif(nif)) {
			return { incorrectFormat: true };
		}
		return null;
	};
}

function isValidSpanishNif(nif: string): boolean {
	if (/^[0-9]{8}[A-Z]$/.test(nif)) {
		const num = Number.parseInt(nif.slice(0, 8), 10);
		if (Number.isNaN(num)) return false;
		return CHECK_LETTERS[num % 23] === nif[8];
	}
	if (/^[XYZ][0-9]{7}[A-Z]$/.test(nif)) {
		const prefix = nif[0] === 'X' ? '0' : nif[0] === 'Y' ? '1' : '2';
		const num = Number.parseInt(prefix + nif.slice(1, 8), 10);
		if (Number.isNaN(num)) return false;
		return CHECK_LETTERS[num % 23] === nif[8];
	}
	return false;
}
